import Vue from 'vue'
import Vuex from 'vuex'

import {eventService} from '../api/event.service';
import {eventTemplateService} from '../api/event-template.service';
import {userProfileService} from '../api/user-profile.service';
import {formStyleService} from '../api/form-style.service';
import {bookingTypeService} from '../api/booking-type.service';
import {resourceTypeService} from '../api/resource-type.service';


Vue.use(Vuex);

const state = { 
   EventSlots: [],
   EventTemplates: [],
   FormStyle:[],
   BookingTypes:[],
   EventSlotPatterns:[],
   EventSlots:[],
   UserProfile: null,
   PermissionGroup: [],
   ResourceType:[],
   Resource:[],
};

const mutations = {
   GET_EVENT_SLOT(state, result)
   {
    let idx = state.EventSlots.findIndex(x=>x.id==result.id);
    if (idx!=-1)
        state.EventSlots.splice(idx, 1);
    state.EventSlots.push(result);
   },
   GET_EVENT_TEMPLATE(state, result)
   {
        let idx = state.EventTemplates.findIndex(x=>x.Identity==result.id);
        if (idx!=-1)
            state.EventTemplates.splice(idx, 1);
        state.EventTemplates.push(result);
   },
   REMOVE_EVENT_TEMPLATE(state, id)
   {
        let idx = state.EventTemplates.findIndex(x=>x.Identity==id);
        if (idx!=-1)
            state.EventTemplates.splice(idx, 1);
   },
   GET_USER_PROFILE(state, result)
   {
       state.UserProfile = result;
   },
   GET_FORM_STYLE(state, result)
   {
       state.FormStyle = result;
   },
   GET_BOOKING_TYPE(state, result)
   {
       state.BookingTypes = result;
   },
   GET_EVENT_SLOTPATTERN(state, result)
   {
       state.EventSlotPatterns = result;
   },
   POST_EVENT_SLOTPATTERN(state, result)
   {
        let idx = state.EventSlotPatterns.findIndex(x=>x.Identity==result.Identity);
        if (idx!=-1)
            state.EventSlotPatterns.splice(idx, 1);
        state.EventSlotPatterns.push(result);
   },
   DEL_EVENT_TEMPLATE(state, id)
   {
        let idx = state.EventSlotPatterns.findIndex(x=>x.Identity==id);
        if (idx!=-1)
            state.EventSlotPatterns.splice(idx, 1);
   },
   GET_PERMISSION_GROUP(state, result)
   {
       state.PermissionGroup = result;
   },
   GET_RESOURCE_TYPE(state, result)
   {
       state.ResourceType = result;
   },
   GET_RESOURCE_BY_TYPE(state, result)
   {
        let idx = state.Resource.findIndex(x=>x.id==result.id);
        if (idx!=-1)
            state.Resource.splice(idx, 1);
        state.Resource.push(result);
   }
};

const actions = {
    async getEventSlot({commit},payload)
    {
        let result = await eventService.getEventSlot(payload);
        commit('GET_EVENT_SLOT', {id: payload.id, slots: result});
    },
    async getEventTemplate({commit}, id)
    {
        let result = await eventTemplateService.getEventTemplate(id);
        commit('GET_EVENT_TEMPLATE', result);

    },
    async postEventTemplate({commit}, payload)
    {
        let result = await eventTemplateService.postEventTemplate(payload);
        commit('GET_EVENT_TEMPLATE', result);

    },
    async patchEventTemplate({commit}, payload)
    {
        let result = await eventTemplateService.patchEventTemplate(payload);
        commit('GET_EVENT_TEMPLATE', result);

    },
    async delEventTemplate({commit}, id)
    {
        let result = await eventTemplateService.delEventTemplate(id);
        commit('REMOVE_EVENT_TEMPLATE', id);

    },
    async postBatchBook({commit}, payload)
    {
        let result = await eventService.postBatchBook(payload);
    },
    async getUserProfile({commit})
    {
        let result = await userProfileService.getUserProfile();
        commit('GET_USER_PROFILE', result);
    },
    async getFormStyle({commit})
    {
        let result = await formStyleService.getFormStyle();
        commit('GET_FORM_STYLE', result);
    },
    async getBookingType({commit})
    {
        let result = await bookingTypeService.getBookingType();
        commit('GET_BOOKING_TYPE', result);
    },
    async getEventSlotPattern({commit})
    {
        let result = await bookingTypeService.getEventSlotPattern();
        commit('GET_EVENT_SLOTPATTERN', result);
    },
    async postEventSlotPattern({commit},payload)
    {
        let result = await bookingTypeService.postEventSlotPattern(payload);
      //  commit('POST_EVENT_SLOTPATTERN', result);
    },
    async patchEventSlotPattern({commit},payload)
    {
        let result = await bookingTypeService.patchEventSlotPattern(payload);
      //  commit('POST_EVENT_SLOTPATTERN', result);
    },
    async delEventSlotPattern({commit},id)
    {
        let result = await bookingTypeService.delEventSlotPattern(id);
        commit('DEL_EVENT_SLOTPATTERN', id);
    },
    async getPermissionGroup({commit})
    {
        let result = await userProfileService.getPermissionGroup();
        commit('GET_PERMISSION_GROUP', result);
    },
    async getResourceType({commit})
    {
        let result = await resourceTypeService.getResourceType();
        commit('GET_RESOURCE_TYPE', result);
    },
    async getResourceByType({commit},id)
    {
        let result = await resourceTypeService.getResourceByType(id);
        commit('GET_RESOURCE_BY_TYPE', {id: id, resource: result});
    }
};

const getters = {
   eventSlot: state => id => {
       let result = state.EventSlots.find(x=>x.id===id);
       if (!result) return null;
       return result.slots;
   },
   eventTemplate: state => id => state.EventTemplates.find(x=>x.Identity==id),
   formStyles: state => id => {
     return  state.FormStyle.find(x=>x.Identity==id)
   },
   FormStyles: state => state.FormStyle,
   userProfile: state => state.UserProfile,
   bookingTypes: state => state.BookingTypes,
   eventSlotPatterns: state => state.EventSlotPatterns,
   permissionGroup: state => state.PermissionGroup,
   resourceType: state => state.ResourceType,
   resourceByType: state => id => {
    let result = state.Resource.find(x=>x.id===id);
    if (!result) return null;
    return result.resource;
   }
};

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
  });
  


// WEBPACK FOOTER //
// ./src/store/index.js